import { useTheme } from "@/contexts/theme/useTheme";
import { EditPencilIcon } from "@/components/icons/edit-pencil-icon";
import { TrashIcon } from "@/components/icons/trash-icon";
import { HpEditIcon } from "@/themes/hp-client/icons/HpEditIcon";
import { HpDeleteIcon } from "@/themes/hp-client/icons/HpDeleteIcon";

const MenuEditIcon = () => {
  const { currentTheme } = useTheme();
  const isHpClient = currentTheme === "hp-client";
  if (isHpClient) {
    return <HpEditIcon />;
  }
  return <EditPencilIcon height={20} width={20} color={"#8283BE"} />;
};

const MenuDeleteIcon = () => {
  const { currentTheme } = useTheme();
  const isHpClient = currentTheme === "hp-client";
  if (isHpClient) {
    return <HpDeleteIcon />;
  }
  return <TrashIcon height={20} width={20} color={"#8283BE"} />;
};

export { MenuEditIcon, MenuDeleteIcon };
